module.exports = __webpack_public_path__ + "static/media/BackExtensionMale.accb464f.svg";